import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
import HomePage from './pages/HomePage/HomePage';
import QuizPage from './pages/QuizPage/QuizPage';
import './App.css'

function App() {

    const [smallScreen, setSmallScreen] = useState(window.innerWidth <= 800 ? true : false)

    function handleResize(){
    if(window.innerWidth <= 800){
        setSmallScreen(true)
    }else{
        setSmallScreen(false)
    }
  }

  useEffect(()=> {
      window.addEventListener("resize", handleResize)

      return () => {
          window.removeEventListener("resize", handleResize)
      }
  }, [])

    return (
        <Router>
        <Routes>
            <Route path="/" element={<HomePage smallScreen={smallScreen} />} />
            <Route path="/quiz" element={<QuizPage smallScreen={smallScreen} />} />
        </Routes>
        </Router>
    );
}

export default App;